module.exports = __webpack_public_path__ + "img/pwa-notifications-desktop.7f50a21a.png";